/**
 * External Dependencies
 */
import $ from 'jquery';
import AOS from 'aos';
import Player from '@vimeo/player';

window.addEventListener('load', () => {
  (function () {
    function handleMailchimpForm() {
      let mcForm = document.querySelector('#mc-embedded-subscribe-form');

      if (mcForm !== null) {
        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        // Store the height of the form so we don't get any resizing when we show a different state.

        function resizeFormContainer() {
          requestAnimationFrame(() => {
            const formContainer = document.querySelector(
              '.block-mailchimp .form-container'
            );

            if (formContainer) {
              formContainer.style.height = formContainer.offsetHeight + 'px';
            }
          });
        }

        resizeFormContainer();

        window.addEventListener('resize', resizeFormContainer);

        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

        let mcConfirmation = document.querySelector('.mc__confirmation');
        let mcError = document.querySelector('.mc__error');

        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        const showState = ''; // Blank for Form

        switch (showState) {
          case 'confirmation':
            console.log('confirmation');
            showConfirmation(true);
            break;

          case 'error':
            showErrorState(true);
            break;
        }

        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

        let name = mcForm.querySelector('#mce-FNAME'),
          email = mcForm.querySelector('#mce-EMAIL'),
          terms = mcForm.querySelector('#mce-MMERGE6-0'),
          submit = mcForm.querySelector('[type="submit"]');

        function showErrorState(displayError) {
          mcForm.classList.toggle('hidden', displayError);
          mcError.classList.toggle('hidden', !displayError);

          let btn = mcError.querySelector('button');

          console.log({ btn });

          btn.addEventListener('click', () => {
            showErrorState(false);
          });
        }

        function showConfirmation(displayConfirmation) {
          mcForm.classList.toggle('hidden', displayConfirmation);
          mcConfirmation.classList.toggle('hidden', !displayConfirmation);
        }

        function isNameValid() {
          return name.value.length > 0;
        }

        function isEmailValid() {
          return (
            email.value.length > 0 &&
            /(.+)@(.+){2,}\.(.+){2,}/.test(email.value)
          );
        }

        function hasAcceptedTerms() {
          return terms.checked;
        }

        document.addEventListener('keyup', () => {
          // Check if the name is populated
          if (name.value.length > 0) {
            name.classList.toggle('error', false);
          }

          // Check if the email is populated and valid
          if (email.value.length > 0) {
            submit.classList.remove('btn--disabled');
            submit.disabled = false;

            if (isEmailValid()) {
              email.classList.toggle('error', false);
            }

            return;
          }

          submit.classList.add('btn--disabled');
          submit.disabled = true;
        });

        // click handler
        mcForm.addEventListener('submit', function (e) {
          e.preventDefault();

          let error = false;

          // Check that the user has entered a name
          if (!isNameValid()) {
            console.error('Name not populated');
            name.classList.toggle('error', true);
            error = true;
          }

          // Çheck that the email is populated and valid
          if (!isEmailValid()) {
            console.error('Email not valid');
            email.classList.toggle('error', true);
            error = true;
          }

          // Check that the user has accepted the terms
          if (!hasAcceptedTerms()) {
            console.error('Terms not accepted');
            terms.classList.toggle('error', true);
            error = true;
          }

          if (error) return;

          $.ajax({
            type: 'GET',
            url: mcForm.action,
            data: $('#mc-embedded-subscribe-form').serialize(),
            cache: false,
            dataType: 'jsonp',
            contentType: 'application/json; charset=utf-8',
            error: function (xhr, ajaxOptions, thrownError) {
              showErrorState(true);
            },
            success: function (res) {
              if (res.result === 'success') {
                showConfirmation(true);
              } else {
                showErrorState(true);
              }
            },
          });
        });
      }
    }

    function handleCareersBlock() {
      let block = document.querySelector('.careers-block');

      if (block !== null) {
        let bulletin = block.querySelector('#bulletin'),
          loading = block.querySelector('.careers-block__loading');

        function createElement(tag, classes) {
          let element = document.createElement(tag);

          element.classList.add(classes);

          return element;
        }

        function showAllChildren(parent) {
          parent.forEach((child) => {
            child.classList.remove('hidden');
          });
        }

        // inital populating
        fetch('https://www.dayforcehcm.com/api/tinbuilding/v1/jobfeeds/')
          .then((response) => response.json())
          .then((data) => {
            // hide loading message
            loading.classList.add('hidden');

            // create, populate and append each post
            data.forEach((data, index) => {
              // create elements for post
              let column = createElement('DIV', 'col-span-6'),
                article = createElement('ARTICLE', 'careers-block__article');

              let info = createElement('ARTICLE', 'careers-block__info'),
                infoHeading = createElement('H2', 'careers-block__heading'),
                infoText = createElement('P', 'careers-block__text'),
                infoTextDescription = createElement(
                  'SPAN',
                  'careers-block__description'
                ),
                infoTextReadMore = createElement(
                  'SPAN',
                  'careers-block__read-more'
                );

              let button = createElement('BUTTON', 'careers-block__button'),
                link = createElement('A', 'careers-block__link');

              if (index > 11) {
                column.classList.add('hidden');
              }

              // manipulate title and description
              let title = `${data.Title.toLowerCase()
                .replace(', tin building by jean-georges', '')
                .replace(', iin building by jean-georges', '')
                .replace(', inn building by jean-georges', '')}`;

              if (title.length > 44) {
                title = title.substr(0, 44);
                title += '...';
              }

              let description = `
                  ${data.Description.replace('POSITION SUMMARY:', '')
                    .replace('POSITION SUMMARY :', '')
                    .replace('POSITION SUMMARY', '')
                    .replace('POSITION:', '')
                    .replace('SUMMARY:', '')
                    .replace('ABOUT THE TIN BUILDING BY JEAN-GEORGES:', '')
                    .substring(0, 132)}... `;

              // populate elements
              infoHeading.innerText = title;
              infoTextDescription.innerText = description;
              infoTextReadMore.innerHTML =
                '<span class="whitespace-nowrap">Read more →</span>';
              link.href = data.JobDetailsUrl;
              link.target = '_blank';
              button.innerText = 'APPLY';

              // append elements
              infoText.append(infoTextDescription);
              infoText.append(infoTextReadMore);

              info.append(infoHeading);
              info.append(infoText);

              article.append(info);
              article.append(button);
              article.append(link);

              column.append(article);

              // append post to DOM
              bulletin.append(column);
            });

            // load remaining posts of inital load when scrolled
            // to the bottom of the page
            window.addEventListener('scroll', () => {
              if (!bulletin.classList.contains('loaded')) {
                if (
                  $(window).scrollTop() + $(window).height() >
                  $(document).height() - 100
                ) {
                  showAllChildren(Array.from(bulletin.children));
                  bulletin.classList.add('loaded');
                }
              }
            });
          })
          .catch((error) => {
            console.log(error);
          });

        // search functionality
        block.addEventListener('click', (e) => {
          let form = block.querySelector('.careers-block__form'),
            input = form.querySelector('[type="text"]'),
            noResultsMessage = block.querySelector(
              '.careers-block__no-results'
            ),
            items = Array.from(bulletin.children);

          // prevent default if not a post link
          if (!e.target.classList.contains('careers-block__link')) {
            e.preventDefault();
          }

          // handle submit button click
          if (e.target.classList.contains('btn')) {
            let searchValue = input.value.toLowerCase();

            // show all posts by default
            showAllChildren(items);

            // hide posts that don't contain search value
            items.forEach((item) => {
              let heading = item
                  .querySelector('.careers-block__heading')
                  .innerText.toLowerCase(),
                description = item
                  .querySelector('.careers-block__heading')
                  .innerText.toLowerCase();

              if (
                heading.indexOf(searchValue) == -1 ||
                description.indexOf(searchValue) == -1
              ) {
                item.classList.add('hidden');

                return;
              }

              item.classList.remove('hidden');
            });

            // if all posts have a class of 'hidden', show no results message
            if (bulletin.querySelectorAll('.hidden').length == items.length) {
              noResultsMessage.classList.remove('hidden');
            } else {
              noResultsMessage.classList.add('hidden');
            }
          }

          // handle clear link click
          if (e.target.classList.contains('careers-block__clear')) {
            showAllChildren(items);
            input.value = '';
            input.focus();
            noResultsMessage.classList.add('hidden');
          }
        });
      }
    }

    function handleVideoBlock() {
      let block = document.querySelector('.video');

      function toggleClass(element, classes) {
        element.classList.toggle(classes);
      }
      
      if (block !== null) {
        let iframe = block.querySelector('iframe'),
          overlay = block.querySelector('.video__overlay'),
          player = new Player(iframe);
        
        overlay.addEventListener('click', () => {
          player.play();
          toggleClass(overlay, 'is-hidden');
        })

        player.on('ended', () => {
          toggleClass(overlay, 'is-hidden');
        })
      }
    }

    function handleAos() {
      AOS.init({
        duration: 1000,
        once: true,
      });
    }

    function handleCookies() {
      const cookies = document.querySelector('.cookies'),
        cookiesCross = document.querySelector('.cookies__cross'),
        cookiesBtn = document.querySelector('.cookies__btn');

      let cookie_consent = getCookie('user_cookie_consent');

      if (cookie_consent != '') {
        cookies.classList.add('active');
      } else {
        cookies.classList.remove('active');
      }

      cookiesCross.addEventListener('click', () =>
        cookies.classList.add('active')
      );
      cookiesBtn.addEventListener('click', () => acceptCookieConsent());

      // Create cookie
      function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
      }

      // Delete cookie
      function deleteCookie(cname) {
        const d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
        let expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=;' + expires + ';path=/';
      }

      // Read cookie
      function getCookie(cname) {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return '';
      }

      // Set cookie consent
      function acceptCookieConsent() {
        deleteCookie('user_cookie_consent');
        setCookie('user_cookie_consent', 1, 30);
        document.querySelector('.cookies').classList.add('active');
      }
    }

    // ////////////////////////////////////////////////////////////////////

    function handleTicker() {
      var containerEl = document.querySelector(
        '.block-ticker .content-container'
      );

      if (!containerEl) return;

      var contentEl = containerEl.querySelector('.content');

      var templateEl = contentEl.querySelector('.content-template');

      var templateWidth = templateEl.offsetWidth;

      var howMany = Math.ceil(window.screen.availWidth / templateWidth);

      var currentLeftValue = 0;

      var speed = 1;

      for (let index = 0; index < howMany; index++) {
        var newNode = templateEl.cloneNode(true);
        contentEl.appendChild(newNode);
      }

      window.setInterval(animationLoop, 1000 / 60);

      function animationLoop() {
        var leftSideOfContainer = containerEl.getBoundingClientRect().left;

        const firstListItem = contentEl.children[0];

        let rightSideOfFirstItem = firstListItem.getBoundingClientRect().right;

        if (rightSideOfFirstItem <= leftSideOfContainer) {
          currentLeftValue = -speed;
          contentEl.appendChild(firstListItem);
        }

        // The part that keeps it all going: animating the margin left value of the list.
        contentEl.style.marginLeft = `${currentLeftValue}px`;
        currentLeftValue -= speed;
      }
    }

    // ////////////////////////////////////////////////////////////////////

    handleCareersBlock();
    handleVideoBlock();
    handleMailchimpForm();
    handleAos();
    handleCookies();
    handleTicker();
  })();
});
